import { rqx } from "../request/API"
import { env } from "../Env"

export const postFeatureInteraction = async (payload) => {
    // const samplePayload = {
    //     aid:"YWNjb3VudF80", // SESSION OF USER, varchar
    //     tid:integer, // Tool ID
    //     company_id:integer, // For biz company_id of users. For Personal default value is 0
    //     feature_id:integer, // feature_id or sub_feature_id
    //     feature_name:varchar, // make it lowercase
    //     path:varchar, // path location of your feature. ex: For main feature "feature_id like 1" if sub feature "feature_id -> sub_feature_id like 1->1"
    // }
    return await rqx.post(`<<global>>/${env()==='local'?'dev':env()}/trail/featurelogs`, payload)
}